module.exports = __webpack_public_path__ + "static/img/18.984e3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/18.png
// module id = 9pjW
// module chunks = 0